/**
 * Status impact of a single event on the patient chat state, or `undefined` when the event
 * leaves the status untouched (snippet-only and technical events).
 *
 * Single source of truth shared by the snapshot (`getPatientChatState`) and the incremental
 * fold (`getPatientChatStateFold`) so both projections can never disagree on status.
 * `AGENT_MESSAGE`/`AGENT_QUESTION` unblock the patient (ACTIVE) only when targeted at them;
 * staff-targeted ones mean background work is still in progress (BUSY).
 *
 * @__NO_SIDE_EFFECTS__
 */
export function getPatientEventStatus(event) {
    switch (event.type) {
        case 'AGENT_BUSY':
        case 'AGENT_SUMMARY':
        case 'STAFF_ANSWER':
        case 'STAFF_PROMPT':
            return 'BUSY';
        case 'AGENT_COMPLETE':
        case 'AGENT_DONE':
            return 'ACTIVE';
        case 'AGENT_MESSAGE':
        case 'AGENT_QUESTION':
            return event.target === 'PATIENT' ? 'ACTIVE' : 'BUSY';
        case 'CHAT_END':
            return 'ENDED';
        case 'PROFILE_DATA_REQUEST':
        case 'STAFF_MESSAGE':
        case 'SUBSCRIPTION_REQUEST':
            return 'ACTIVE';
        default:
            return undefined;
    }
}
//# sourceMappingURL=getPatientEventStatus.js.map